import type {
  ProfilePage,
  UsersPermissionsUser,
  UsersPermissionsUserInput,
} from '@edwin-group/cj-graphql/generated/graphql';
import uploadFile from '@/services/files/upload.service';
import { updatePassword, updateUser } from '@/services/profile/profile.service';
import { create } from 'zustand';

interface ProfileStore {
  user: UsersPermissionsUser;
  page: ProfilePage;
  onUpdateInfo: (userInput: UserProfileInfo) => Promise<void>;
  onUpdatePassword: ({
    currentPassword,
    password,
    passwordConfirmation,
  }: {
    currentPassword: string;
    password: string;
    passwordConfirmation: string;
  }) => Promise<{
    error: string | undefined;
  }>;
}

interface UserProfileInfo {
  location: string;
  surname: string;
  forename: string;
  profile: string;
  photo: File;
}

export const useProfileStore = create<ProfileStore>()((_, get) => ({
  user: {} as UsersPermissionsUser,
  page: {} as ProfilePage,
  onUpdateInfo: async (userInput: UserProfileInfo) => {
    if (userInput.photo) {
      const { data: uploadResponse } = await uploadFile(userInput.photo);
      userInput.photo = uploadResponse?.[0]?.id;
    }

    const { error } = await updateUser(get().user.id!, userInput as unknown as UsersPermissionsUserInput);
    if (error) {
      throw new Error(error);
    }
  },
  onUpdatePassword: async ({
    currentPassword,
    password,
    passwordConfirmation,
  }: {
    currentPassword: string;
    password: string;
    passwordConfirmation: string;
  }) => {
    const { error } = await updatePassword({ currentPassword, password, passwordConfirmation });
    return { error };
  },
}));
